// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"vehicleSelectorSelected_imageWrapper__bJNHX","grid_item":"vehicleSelectorSelected_grid_item__ylwZq"};